import React from "react";

const Temoignages = () => {
    const testimonials = [
        {
            quote: "J'ai eu la chance d'étudier à Vatel, une école qui m'a énormément appris sur le monde de l'hôtellerie et de la restauration. Grâce aux stages et aux applications pratiques dans les hôtels partenaires, j'ai pu entrer directement dans la réalité du travail, telle que je la vivrai dans ma future carrière.",
            name: "Lou de gemini",
            title: "Vatelienne (Bachelor – promotion 2025)"
        },
        {
            quote: "Ce qui m'a marqué, ce sont surtout les nombreuses expériences professionnelles : plusieurs mois de stages à l'étranger, qui m'ont permis de m'immerger dans différentes cultures, de gagner en autonomie et en adaptabilité, mais aussi une partie en pratique dans des hôtels 4 et 5 étoiles à Bruxelles, au contact direct de professionnels exigeants.",
            name: "Léonard Lemaire",
            title: "Vatelien (Bachelor – promotion 2025)"
        },
        {
            quote: "Le programme est varié et complet : ressources humaines, marketing, comptabilité, droit, communication… Les cours en anglais apportent une véritable dimension internationale, tout en offrant la possibilité d'obtenir des explications en français si nécessaire.",
            name: "Aurora Cervini",
            title: "Vatelienne (Bachelor – promotion 2025)"
        }
    ];

    return (
        <div id="temoignages" className="section-padding tw-bg-gradient-to-b tw-from-gray-50 tw-to-transparent">
            <div className="container">
                <div className="text-center">
                    <div className="mini-title">Témoignages</div>
                    <div className="column-title tw-leading-tight">
                        Ce que disent nos <span className="shape-bg">étudiants</span>
                    </div>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-3 tw-gap-8 mt-8">
                    {testimonials.map((testimonial, index) => (
                        <div key={index} className="tw-bg-white tw-rounded-xl shadow-box14 tw-p-6">
                            <div className="tw-mb-4">
                                <svg className="tw-w-12 tw-h-12 tw-text-teal-500 tw-mb-4" fill="currentColor" viewBox="0 0 32 32">
                                    <path d="M10 8C8.895 8 8 8.895 8 10v12c0 1.105.895 2 2 2h4c1.105 0 2-.895 2-2v-6c0-1.105-.895-2-2-2h-2v-2c0-.552.448-1 1-1h1c.552 0 1-.448 1-1s-.448-1-1-1h-1C9.343 9 8.687 9.687 8.687 10.5 8.687 10.224 8.776 9.949 8.949 9.78L10 8zM22 8c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2h4c1.105 0 2-.895 2-2v-6c0-1.105-.895-2-2-2h-2v-2c0-.552.448-1 1-1h1c.552 0 1-.448 1-1s-.448-1-1-1h-1C21.343 9 20.687 9.687 20.687 10.5c0-.276.089-.551.262-.72L22 8z"/>
                                </svg>
                                <p className="tw-text-gray-700 tw-leading-relaxed tw-italic">
                                    "{testimonial.quote}"
                                </p>
                            </div>
                            <div className="tw-border-t tw-pt-4">
                                <p className="tw-text-gray-900 tw-text-sm">
                                    {testimonial.name}, <span className="tw-text-teal-600">{testimonial.title}</span>
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Temoignages;